import { clearFilterParams, useCleanFilterForRequest } from '@btime/react-contexts'
import { gql } from '@apollo/client'
import { mergeDeepLeft, pick } from 'ramda'
import React from 'react'

import { accountsClient } from '../../../../../../utils/apollo/api'
import { useQuery } from '../../../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../../../packages/kiti/components/helpers/StatePresenter'

const Context = React.createContext([])
const { Provider } = Context
export const useUsersCounterState = () => React.useContext(Context)
export const useUsersCounter = () => useUsersCounterState()?.usersCount
export const useAllUsersCounter = () => useUsersCounterState()?.all

const QUERY = gql`
  query UsersCount($filter: UserFilter, $fixedFilter: UserFilter) {
    usersCount(filter: $filter)
    all: usersCount(filter: $fixedFilter)
  }
`

const UsersCounterLoader = ({ widget, children }) => {
  const widgetFilter = clearFilterParams(widget.data?.filters || []) || {}
  const ignoreDate = widget?.data?.ignoreDate
  const { date, ...manualFilter } = pick(['date'], useCleanFilterForRequest() || {})
  const insertedAt = !ignoreDate ? date : undefined
  const fullFilter = mergeDeepLeft(widgetFilter, manualFilter)

  const { data, ...state } = useQuery(QUERY, {
    variables: { filter: { ...fullFilter, insertedAt }, fixedFilter: { ...manualFilter, insertedAt } },
    client: accountsClient
  })

  return (
    <StatePresenter {...state}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default UsersCounterLoader
